 <template>
  <div class="video-player-box">
    <div :id="`video_player_${id}`" ref="xg_video_player_ref"></div>
  </div>
</template>

<script>

// 函数方法 start
import xgPlayer from 'xgplayer';
import { assign } from '@/utils/utils';
// 函数方法 end

export default {
  props: {
    id: [Number,String],
    url: [String],
    poster: [String],
    config: [Object],
  },
  data() {
    return {
      playerModel: null,
    }
  },
  watch: {
    url: function() {
      this.switchPlayUrl();
    },
    poster: function() {
      this.setPoster();
    },
  },
  mounted() {
    this.initPlayer();
  },
  methods: {
    getPlayerElement: function() {

    },
    getDefaultParams: function() {
      let params = {
        // 'el': this.$refs.xg_video_player_ref,
        "playsinline": true,
        "closeVideoTouch": true,
        "closeVideoDblclick": true,
        "closeVideoClick": true,
        "x5-video-orientation": "portraint",
        "x5-video-player-fullscreen": "false",
        "x5-video-player-type": "h5",
        "closeInactive": true,
        "controls": false,
        "rotateFullscreen": true,
        autoplay: false,
        fluid: true, // 按照父级宽高显示
        videoInit: true , // 初始化显示视频首帧
      };

      if (this.id) {
        params.id = `video_player_${this.id}`;
      } else {
        params.el = this.$refs.xg_video_player_ref;
      };
    
      return params;
    },
    getPlayInfo: function() {
      const defaultData = this.getDefaultParams();
      let playData = assign(defaultData,this.config || {});
      playData.url = this.url;
      playData.poster = this.poster;
      // playData.url = this.url || "http://p0rwwxijh.bkt.clouddn.com/section_resource_video-1589167766246";
      // playData.url = "http://a0ced32fbd50150947d2.test.upcdn.net/apicloud/9822de3cdeeda47530e64707a3c5b853.mp4";
      // playData.poster = 'https://gpets.oss-accelerate.aliyuncs.com/upload/user_image/202108/1629102569kPD1';
      
      return playData;
    },
    initPlayer: function() {
      const playData = this.getPlayInfo();

      this.playerModel = new xgPlayer(playData);
      this.setVideoPlayerListener();
    },
    // ------ 播放控制 start
    // 切换封面图
    setPoster: function() {
      this.playerModel.poster = this.poster;
    },
    // 切换播放地址
    switchPlayUrl: function() {
      this.playerModel.src = this.url;

      this.setPauseStatus(true);
    },
    // 设置当前播放时间
    setCurrentTime: function(seconds) {
      this.playerModel.currentTime = seconds;
    },
    // 设置播放或暂停
    setPauseStatus: function(isPause) {
      if (isPause) {
        this.playerModel.pause();
      } else {
        this.playerModel.play();
      }
    },
    setMultiple: function(num) {
      this.playerModel.playbackRate = num;
    },
    setFullScreenStatus: function(status) {
      if (status) {
        this.playerModel.getFullscreen(this.playerModel.root);
      } else {
        this.playerModel.exitFullscreen(this.playerModel.root);
      }
    },
    // ------ 播放控制 end
    // 状态监听 start
    setVideoPlayerListener: function() {
      // 视频可以播放
      this.playerModel.on('ready',()=>{
        this.setSendVideoStatusData('ready');
      }).on('complete',()=>{
        setTimeout(()=>{
          this.setSendVideoStatusData('complete');
        },500)
      }).on('canplay',()=>{
        this.setSendVideoStatusData('canplay');
      }).on('play',()=>{
        this.setSendVideoStatusData('play');
      }).on('pause',()=>{
        this.setSendVideoStatusData('pause');
      }).on('timeupdate',()=>{
        this.setSendVideoStatusData('timeupdate');
      }).on('seeking',()=>{
        this.setSendVideoStatusData('seeking');
      }).on('waiting',()=>{
        this.setSendVideoStatusData('waiting');
      }).on('ended',()=>{
        this.setSendVideoStatusData('ended');
      }).on('durationchange',()=>{
        this.setSendVideoStatusData('durationchange');
      }).on('bufferedChange',()=>{
        this.setSendVideoStatusData('bufferedChange');
      }).on('error',()=>{
        this.setSendVideoStatusData('error');
      })
    },
    // 状态监听 end
    setSendVideoStatusData: function(statusType) {
      const playerModel = this.playerModel;
      const isPause = playerModel.paused;
      const currentTime = playerModel.currentTime || 0;
      const duration = playerModel.duration || 0;
      const muted = playerModel.muted;
      const error = playerModel.error;

      let videoData = {
        statusType: statusType,
        url: this.url,
        poster: this.poster,
        isPause: isPause,
        duration: duration,
        currentTime: currentTime,
        muted: muted,
        error: error
      };

      this.sendVideoStatus(videoData);
    },
    sendVideoStatus: function(statusInfo) {
      this.$emit('statusChange',statusInfo)
    },
  },
};
</script>

<style lang="less">
  .video-player-box {
    position: relative!important;
    width: 100%;
    height: 100%;
    &>div {
      position: relative!important;
      width: 100%;
      height: 100%!important;
      padding: 0!important;
    }

    .xgplayer-skin-default .xgplayer-enter,
    .xgplayer-skin-default .xgplayer-loading,
    .xgplayer-skin-default .xgplayer-error,
    .xgplayer-skin-default .xgplayer-start,
    .xgplayer-skin-default .xgplayer-replay {
      display: none!important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/video_player/player/xigua.vue